import React from 'react';

import {CONSIGNEE_NAME, ViewKeys} from '.';

import {ModuleItem} from 'commons/types/Types';
import TaxId from 'modules/data-documentation/tax-id/TaxId';
import {
    Init,
    NotFound,
    Login,
    RecoverPassword,
    ResetPassword,
    ServiceContract,
    MigratedUser,
} from 'modules';
import {BeforeStart, TermsAndConditions} from 'modules/content';
import DocsAct from 'modules/data-documentation/docs-act/DocsAct';
import FiscalLocation from 'modules/fiscal-location/FiscalLocation';
import DocsSign from 'modules/data-documentation/docs-sign/DocsSign';
import DocsInfo from 'modules/data-documentation/docs-info/DocsInfo';
import DataDocumentation from 'modules/data-documentation/DataDocumentation';
import AddressProof from 'modules/fiscal-location/address-proof/AddressProof';
import LocationInfo from 'modules/fiscal-location/location-info/LocationInfo';
import ExpedientManual from 'modules/register/expedient-manual/ExpedientManual';
import ProfileInfo from 'modules/transactional-profile/profile-info/ProfileInfo';
import TransactionaProfile from 'modules/transactional-profile/TransactionalProfile';
import RegulatoryFramework from 'modules/register/regulatory-framework/RegulatoryFramework';
import DocsIdentification from 'modules/data-documentation/docs-identification/DocsIdentification';
import LegalRepresentative from 'modules/legal-representative/LegalRepresentative';
import RepresentativePersonalInfo from 'modules/legal-representative/representative-personal-info/RepresentativePersonalInfo';
import RepresentativeOfficialInfo from 'modules/legal-representative/representative-official-info/RepresentativeOfficialInfo';
import RepresentativeOfficialId from 'modules/legal-representative/representative-official-id/RepresentativeOfficialInfo';
import RepresentativeAdditionalInfo from 'modules/legal-representative/representative-additional-info/RepresentativeAdditionalInfo';
import RepresentativePowerAttorney from 'modules/legal-representative/representative-power-attorney/RepresentativePowerAttorney';
import RepresentativeSign from 'modules/legal-representative/representative-sign/RepresentativeSign';
import Shareholders from 'modules/shareholders/Shareholders';
import ShareholderPersonalInfo from 'modules/shareholders/shareholder-personal-info/ShareholderPersonalInfo';
import ShareholderLegalRepresentative from 'modules/shareholders/shareholder-legal-representative/ShareholderLegalRepresentative';
import AuthClient from 'modules/auth-client/AuthClient';
import Dashboard from 'modules/dashboard/Dashboard';
import RealOwner from 'modules/real-owner/RealOwner';
import RealOwnerPersonalInfo from 'modules/real-owner/real-owner-personal-info/RealOwnerPersonalInfo';
import RealOwnerLocationInfo from 'modules/real-owner/real-owner-location-info/RealOwnerLocationInfo';
import ClientStatus from 'modules/client-status/ClientStatus';
import Beneficiary from 'modules/beneficiary/Beneficiary';
import BeneficiaryPersonalInfo from 'modules/beneficiary/views/personal-info/BeneficiaryPersonalInfo';
import BeneficiaryAddress from 'modules/beneficiary/views/address/BeneficiaryAddress';
import Consignee from 'modules/consignee/Consignee';
import ConsigneeAddress from 'modules/consignee/consignee-address/ConsigneeAddress';
import ConsigneePersonalInfo from 'modules/consignee/consignee-personal-info/ConsigneePersonalInfo';
import RealOwnerIdentification from 'modules/real-owner/real-owner-identification/RealOwnerIdentification';
import ConsigneeSign from 'modules/consignee/consignee-sign/ConsigneeSign';

export enum HistoryRoutes {
    LOGIN = '/admin/login',
    CLIENT_STATUS = '/admin/client-status',
    BEFORE_START = '/admin/before-start',
    REGISTER = '/admin/expedient-manual',
    PRE_SIGN_TERMS = '/admin/pre-sign-terms',
    REGULATORY_FRAMEWORK = '/admin/regulatory-framework',
    LEGAL_REPRESENTATIVE = '/admin/representative-personal-info',
    COMPLETED_REGISTER = '/admin/completed',
    DASHBOARD = '/admin/employer-dashboard',
    SHAREHOLDER_LEGAL_REPRESENTATIVE = '/admin/shareholder-representative',
    REAL_OWNER_PERSONAL_INFO = '/admin/real-owner-information',

    // Data documentation
    DOCS_INFO = '/admin/docs-info',
    DOCS_ACT = '/admin/docs-act',
    DOCS_IDENTIFICATION = '/admin/docs-identification',
    TAX_ID = '/admin/tax-id',
    DOCS_SIGNATURE = '/admin/docs-signature',
    // Fiscal location
    LOCATION_INFO = '/admin/location-info',
    ADDRESS_PROOF = '/admin/address-proof',
    // Legal representative
    REPRESENTATIVE_PERSONAL = '/admin/representative-personal-info',
    REPRESENTATIVE_OFFICIAL_INFO = '/admin/representative-official-info',
    REPRESENTATIVE_OFFICIAL_ID = '/admin/representative-official-id',
    REPRESENTATIVE_POWER = '/admin/representative-power-attorney',
    REPRESENTATIVE_SIGN = '/admin/representative-sign',
    REPRESENTATIVE_ADDITIONAL = '/admin/representative-additional-info',
    // Beneficiaries
    BENEFICIARY_INFO = '/admin/beneficiary-info',
    BENEFICIARY_ADDRESS = '/admin/beneficiary-address',
    // Shareholder
    SHAREHOLDER_INFO = '/admin/shareholder-info',
    SHAREHOLDER_REPRESENTATIVE = '/admin/shareholder-representative',
    // Real owner
    REAL_OWNER_INFORMATION = '/admin/real-owner-information',
    REAL_OWNER_ADDRESS = '/admin/real-owner-address',
    REAL_OWNER_IDENTIFICATION = '/admin/real-owner-identification',
    // Transactional profile
    TRANSACTIONAL_PROFILE = '/admin/transactional-profile',
    // Consignee
    CONSIGNEE_INFO = '/admin/consignee-info',
    CONSIGNEE_ADDRESS = '/admin/consignee-address',
    CONSIGNEE_SIGN = '/admin/consignee-sing'
}

export enum ViewId {
    LEGAL_REPRESENTATIVE = 'V_REPRESENTANTES_LEGALES',
}

export enum ViewChildId {
    REAL_OWNER_LOCATION_INFO = 'V_DIRECCION',
    REAL_OWNER_PERSONAL_INFO = 'V_INFORMACION',
    REAL_OWNER_OFFICIAL_ID = 'V_IDENTIFICACION_OFICIAL',
    LEGAL_REPRESENTATIVE_OFFICIAL_INFO = 'V_INFORMACION_OFICIAL',
    LEGAL_REPRESENTATIVE_PERSONAL_INFO = 'V_INFORMACION_PERSONAL',
    SHAREHOLDER_V_DATA_INFORMATION_PHYSICAL = 'V_INFORMACION_FISICA',
    SHAREHOLDER_V_DATA_INFORMATION_MORAL = 'V_INFORMACION_MORAL',
    SHAREHOLDER_V_RL_INFORMATION_MORAL = 'V_REPRESNTANTES_LEGALES_MORAL',
    BENEFICIARY_PERSONAL_INFO = 'V_BENEFICIARIOS_DATOS_GENERALES',
    BENEFICIARY_ADDRESS = 'V_BENEFICIARIOS_DOMICILIO',
    CONSIGNEE_INFO = 'V_CONSIGNATARIOS_DATOS_GENERALES',
    CONSIGNEE_ADDRESS = 'V_CONSIGNATARIOS_DATOS_DOMICILIO',
}

export const INITIAL_MODULES: ModuleItem[] = [
    {
        name: 'Inicio',
        title: 'Inicio',
        id: 'init',
        expandKey: '',
        icon: '',
        path: '/init',
        active: false,
        orderId: 1,
        showLinearProgress: false,
        component: Init,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: false,
    },
    {
        name: 'NotFound',
        title: 'NotFound',
        id: 'notFound',
        expandKey: '',
        icon: '',
        path: '/404',
        active: false,
        orderId: 2,
        showLinearProgress: false,
        component: NotFound,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: false,
    },
    {
        name: 'Iniciar Sesi\u00f3n',
        title: 'Iniciar Sesi\u00f3n',
        id: 'login',
        expandKey: '',
        icon: '',
        path: '/login',
        active: false,
        orderId: 3,
        showLinearProgress: false,
        component: Login,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: false,
    },
    {
        name: 'Recupera tu contrase\u00f1a',
        title: 'Recupera tu contrase\u00f1a',
        id: 'recover_password',
        expandKey: '',
        icon: 'action-edit',
        path: '/recover-password',
        active: false,
        orderId: 4,
        showLinearProgress: false,
        component: RecoverPassword,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: false,
    },
    {
        name: 'Restablece tu contrase\u00f1a',
        title: 'Restablece tu contrase\u00f1a',
        id: 'reset_password',
        expandKey: '',
        icon: 'action-edit',
        path: '/reset-password',
        active: false,
        orderId: 5,
        showLinearProgress: false,
        component: ResetPassword,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: false,
    },
];

export const COMPLEMENT_MODULES: ModuleItem[] = [
    {
        name: 'Registro',
        title: 'Antes de Comenzar',
        id: 'before_start',
        expandKey: '',
        icon: 'action-edit',
        path: '/before-start',
        active: false,
        orderId: 6,
        showLinearProgress: false,
        component: BeforeStart,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: false,
    },
    {
        name: 'Estatus de Contrato',
        title: 'Estatus de Contrato',
        id: 'client-status',
        expandKey: '',
        icon: 'owner',
        path: '/client-status',
        active: false,
        orderId: 7,
        showLinearProgress: false,
        component: ClientStatus,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: false,
    },
    {
        name: 'Registro',
        title: 'Antes de Comenzar',
        id: 'terms_conditions',
        expandKey: '',
        icon: 'action-edit',
        path: '/terms-conditions',
        active: false,
        orderId: 8,
        showLinearProgress: false,
        component: TermsAndConditions,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: false,
    },
];

export const MODULES: ModuleItem[] = [
    {
        name: 'Contrato de servicio',
        title: 'Contrato de servicio',
        icon: 'token',
        id: 'V_FIRMA_TERMINOS_CONDICIONES_MIGRADO',
        expandKey: ViewKeys.V_FIRMA_TERMINOS_CONDICIONES_MIGRADO,
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: MigratedUser,
        viewId: 0,
        view: <MigratedUser />,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 9,
        layout: '/admin',
        path: '/pre-sign-terms',
        items: [],
    },
    {
        name: 'Registro',
        title: 'Bienvenido',
        id: 'V_REGISTRO',
        expandKey: '',
        icon: 'action-edit',
        active: false,
        path: '',
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 10,
        layout: '/admin',
        items: [
            {
                id: 'V_MANUAL_EXPEDIENTE',
                expandKey: '',
                name: 'Manual del expediente',
                path: '/expedient-manual',
                showLinearProgress: true,
                component: ExpedientManual,
                viewId: 0,
                view: null,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_MARCO_REGULATORIO',
                expandKey: '',
                name: 'Marco regulatorio',
                path: '/regulatory-framework',
                showLinearProgress: true,
                component: RegulatoryFramework,
                viewId: 0,
                view: null,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 2,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: 'Datos y documentaci\u00f3n',
        icon: 'misc-doc',
        active: true,
        title: 'Registro',
        id: 'V_DATOS_DOCUMENTACION',
        expandKey: '',
        path: '',
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 11,
        layout: '/admin',
        items: [
            {
                id: 'V_INFORMACION',
                expandKey: ViewKeys.DATA_DOCUMENTATION_INFO,
                name: 'Informaci\u00f3n',
                path: '/docs-info',
                showLinearProgress: true,
                component: DataDocumentation,
                viewId: 0,
                view: <DocsInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_ACTA_CONSTITUTIVA',
                expandKey: ViewKeys.DATA_DOCUMENTATION_CONST_ACT,
                name: 'Acta constitutiva',
                path: '/docs-act',
                showLinearProgress: true,
                component: DataDocumentation,
                viewId: 0,
                view: <DocsAct />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 2,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_IDENTIFICACION',
                expandKey: ViewKeys.DATA_DOCUMENTATION_ID,
                name: 'Identificaci\u00f3n',
                path: '/docs-identification',
                showLinearProgress: true,
                component: DataDocumentation,
                viewId: 0,
                view: <DocsIdentification />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 3,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_CEDULA_FISCAL',
                expandKey: ViewKeys.DATA_DOCUMENTATION_TAX_ID,
                name: 'Constancia de situaci\u00F3n Fiscal',
                path: '/tax-id',
                showLinearProgress: true,
                component: DataDocumentation,
                viewId: 0,
                view: <TaxId />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 5,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_FIRMA',
                expandKey: ViewKeys.DATA_DOCUMENTATION_SIGNATURE,
                name: 'Firma digitalizada',
                path: '/docs-signature',
                showLinearProgress: true,
                component: DataDocumentation,
                viewId: 0,
                view: <DocsSign />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 6,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: 'Domicilio Fiscal',
        title: 'Domicilio Fiscal',
        icon: 'misc-location',
        id: 'V_DOMICILIO_FISCAL',
        expandKey: '',
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 12,
        layout: '/admin',
        path: '/fiscal-location',
        items: [
            {
                id: 'V_INFORMACION',
                expandKey: ViewKeys.FISCAL_LOCATION_INFO,
                name: 'Informaci\u00f3n',
                path: '/location-info',
                showLinearProgress: true,
                component: FiscalLocation,
                viewId: 0,
                view: <LocationInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_COMPROBANTE_DOMICILIO',
                expandKey: ViewKeys.FISCAL_LOCATION_ADDRESS,
                name: 'Comprobante de domicilio',
                path: '/address-proof',
                showLinearProgress: true,
                component: FiscalLocation,
                viewId: 0,
                view: <AddressProof />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 2,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: 'Designaci\u00F3n de beneficiarios',
        title: 'Designaci\u00F3n de beneficiarios',
        icon: 'users',
        id: 'V_BENEFICIARIOS',
        expandKey: '',
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 13,
        layout: '/admin',
        path: '/beneficiary',
        items: [
            {
                id: 'V_BENEFICIARIOS_DATOS_GENERALES',
                expandKey: ViewKeys.BENEFICIARY_INFO,
                name: 'Informaci\u00f3n',
                path: '/beneficiary-info',
                showLinearProgress: true,
                component: Beneficiary,
                viewId: 0,
                view: <BeneficiaryPersonalInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_BENEFICIARIOS_DOMICILIO',
                expandKey: ViewKeys.BENEFICIARY_ADDRESS,
                name: 'Direcci\u00f3n',
                path: '/beneficiary-address',
                showLinearProgress: true,
                component: Beneficiary,
                viewId: 0,
                view: <BeneficiaryAddress />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 2,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: 'Representantes legales',
        title: 'Representantes legales',
        icon: 'legal',
        id: 'V_REPRESENTANTES_LEGALES',
        expandKey: '',
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 14,
        layout: '/admin',
        path: '/legal-representative',
        items: [
            {
                id: 'V_INFORMACION_PERSONAL',
                expandKey: ViewKeys.LEGAL_PERSONAL_INFO,
                name: 'Informaci\u00f3n personal',
                path: '/representative-personal-info',
                showLinearProgress: true,
                component: LegalRepresentative,
                viewId: 0,
                view: <RepresentativePersonalInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_INFORMACION_OFICIAL',
                expandKey: ViewKeys.LEGAL_OFFICIAL_INFO,
                name: 'Informaci\u00f3n oficial',
                path: '/representative-official-info',
                showLinearProgress: true,
                component: LegalRepresentative,
                viewId: 0,
                view: <RepresentativeOfficialInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 2,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_IDENTIFICACION_OFICIAL',
                expandKey: ViewKeys.LEGAL_IDENTIFICATION,
                name: 'Identificaci\u00f3n oficial',
                path: '/representative-official-id',
                showLinearProgress: true,
                component: LegalRepresentative,
                viewId: 0,
                view: <RepresentativeOfficialId />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 3,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_PODER_NOTARIAL',
                expandKey: ViewKeys.LEGAL_ATTORNEY_POWER,
                name: 'Poder notarial',
                path: '/representative-power-attorney',
                showLinearProgress: true,
                component: LegalRepresentative,
                viewId: 0,
                view: <RepresentativePowerAttorney />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 4,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_FIRMA',
                expandKey: ViewKeys.LEGAL_SIGNATURE,
                name: 'Firma digitalizada',
                path: '/representative-sign',
                showLinearProgress: true,
                component: LegalRepresentative,
                viewId: 0,
                view: <RepresentativeSign />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 5,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_DATOS_ADICIONALES',
                expandKey: ViewKeys.LEGAL_ADDITIONAL_INFO,
                name: 'Datos adicionales',
                path: '/representative-additional-info',
                showLinearProgress: true,
                component: LegalRepresentative,
                viewId: 0,
                view: <RepresentativeAdditionalInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 6,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: 'Accionistas',
        title: 'Accionistas',
        icon: 'money',
        id: 'V_ACCIONISTAS',
        expandKey: '',
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 15,
        layout: '/admin',
        path: '/shareholder',
        items: [
            {
                id: 'V_INFORMACION_FISICA',
                expandKey: ViewKeys.SHAREHOLDER_PHYSICAL_INFO,
                name: 'Informaci\u00f3n',
                path: '/shareholder-info',
                showLinearProgress: true,
                component: Shareholders,
                viewId: 0,
                view: <ShareholderPersonalInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_REPRESNTANTES_LEGALES_MORAL',
                expandKey: ViewKeys.SHAREHOLDER_REPRESENTATIVE,
                name: 'Representantes legales',
                path: '/shareholder-representative',
                showLinearProgress: true,
                component: Shareholders,
                viewId: 0,
                view: <ShareholderLegalRepresentative />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 3,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: 'Propietario real',
        title: 'Propietario real',
        icon: 'owner',
        id: 'V_PROPIETARIO_REAL',
        expandKey: '',
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 16,
        layout: '/admin',
        path: '/real-owner',
        items: [
            {
                id: 'V_INFORMACION',
                expandKey: ViewKeys.REAL_OWNER_PERSONAL_INFO,
                name: 'Informaci\u00f3n',
                path: '/real-owner-information',
                showLinearProgress: true,
                component: RealOwner,
                viewId: 0,
                view: <RealOwnerPersonalInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_DIRECCION',
                expandKey: ViewKeys.REAL_OWNER_LOCATION_INFO,
                name: 'Direcci\u00f3n',
                path: '/real-owner-address',
                showLinearProgress: true,
                component: RealOwner,
                viewId: 0,
                view: <RealOwnerLocationInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 3,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_PROPIETARIO_REAL_IDENTIFICACION_OFICIAL',
                expandKey: ViewKeys.REAL_OWNER_IDENTIFICATION_INFO,
                name: 'Identificaci\u00f3n',
                path: '/real-owner-identification',
                showLinearProgress: true,
                component: RealOwner,
                viewId: 0,
                view: <RealOwnerIdentification />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 2,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: 'Perfil transaccional',
        title: 'Perfil transaccional',
        icon: 'card',
        id: 'V_PERFIL_TRANSACCIONAL',
        expandKey: '',
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 17,
        layout: '/admin',
        path: '/fiscal-location',
        items: [
            {
                id: 'V_PERFIL',
                expandKey: '',
                name: 'Perfil',
                path: '/transactional-profile',
                showLinearProgress: true,
                component: TransactionaProfile,
                viewId: 0,
                view: <ProfileInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: CONSIGNEE_NAME,
        title: CONSIGNEE_NAME,
        icon: 'consignee',
        id: 'V_CONSIGNATARIOS',
        expandKey: '',
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: null,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 18,
        layout: '/admin',
        path: '/consignee',
        items: [
            {
                id: 'V_CONSIGNATARIOS_DATOS_GENERALES',
                expandKey: ViewKeys.V_CONSIGNEE_INFO,
                name: 'Perfil',
                path: '/consignee-info',
                showLinearProgress: true,
                component: Consignee,
                viewId: 0,
                view: <ConsigneePersonalInfo />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 1,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_CONSIGNATARIOS_DATOS_DOMICILIO',
                expandKey: ViewKeys.V_CONSIGNEE_ADDRESS,
                name: 'Domicilio',
                path: '/consignee-address',
                showLinearProgress: true,
                component: Consignee,
                viewId: 0,
                view: <ConsigneeAddress />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 2,
                layout: '/admin',
                showMenu: true,
            },
            {
                id: 'V_CONSIGNEE_SIGN',
                expandKey: ViewKeys.V_CONSIGNEE_SIGN,
                name: 'Firma digitalizada',
                path: '/consignee-sing',
                showLinearProgress: true,
                component: Consignee,
                viewId: 0,
                view: <ConsigneeSign />,
                thirdLevel: false,
                fatherId: 0,
                linkedFatherId: 0,
                linkedChildId: 0,
                exact: true,
                orderId: 3,
                layout: '/admin',
                showMenu: true,
            },
        ],
    },
    {
        name: 'Enviar expediente a validaci\u00F3n',
        title: 'Enviar expediente a validaci\u00F3n',
        id: 'V_EXPEDIENTE_VALIDACION',
        expandKey: 'V_EXPEDIENTE_VALIDACION',
        icon: 'mail-box',
        path: '/auth-client',
        active: false,
        orderId: 19,
        showLinearProgress: true,
        component: AuthClient,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: true,
    },
    {
        name: 'Contrato de servicio',
        title: 'Contrato de servicio',
        icon: 'token',
        id: 'V_FIRMA_TERMINOS_CONDICIONES',
        expandKey: 'V_FIRMA_TERMINOS_CONDICIONES',
        active: false,
        showMenu: true,
        showLinearProgress: true,
        component: ServiceContract,
        viewId: 0,
        view: <ServiceContract />,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        orderId: 20,
        layout: '/admin',
        path: '/sign-terms',
        items: [],
    },
];

export const DASHBOARD: ModuleItem[] = [
    {
        name: 'Usuarios',
        title: 'Clientes Titulares de Tarjeta',
        id: 'dashboard',
        expandKey: '',
        icon: 'user',
        path: '/employer-dashboard',
        active: false,
        orderId: 21,
        showLinearProgress: false,
        component: Dashboard,
        viewId: 0,
        view: null,
        thirdLevel: false,
        fatherId: 0,
        linkedFatherId: 0,
        linkedChildId: 0,
        exact: true,
        layout: '/admin',
        showMenu: true,
    },
];
